import React from 'react';
import { useTranslation } from "react-i18next";

function Dialog({ dialog }) {
    const {
        msg
    } = dialog;
    const { t } = useTranslation();
    if (!msg) return null;
    return (
        <div className="player--dialog">
            {t(`dialog.${msg}`)}
        </div>
    );
}

export default Dialog;
